<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="机构名称" v-model="name"></el-input>
            </el-col>
            <el-col :span="14">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>
        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="short_name" label="机构名称">
            </el-table-column>
            <el-table-column prop="app_key" label="历史数据">
                <template slot-scope="scope">
                    <el-button style="margin-left: 15px;" @click="openEdit(scope.row,'his')" type="text" size="small">
                        显示控制</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="app_secret" label="参数编辑">
                <template slot-scope="scope">
                    <el-button style="margin-left: 15px;" @click="openEdit(scope.row,'edit')" type="text" size="small">
                        显示控制</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="app_secret" label="终端管理">
                <template slot-scope="scope">
                    <el-button style="margin-left: 15px;" @click="openEdit(scope.row,'terminal')" type="text"
                        size="small">显示控制</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="app_secret" label="在线最新数据">
                <template slot-scope="scope">
                    <el-button style="margin-left: 15px;" @click="openEdit(scope.row,'onlineHis')" type="text"
                        size="small">显示控制</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="app_secret" label="在线历史数据">
                <template slot-scope="scope">
                    <el-button style="margin-left: 15px;" @click="openEdit(scope.row,'onlineLatest')" type="text"
                        size="small">显示控制</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="dialogClose">
            <el-row class="search-add" :gutter="10">
                <el-col :span="4">
                    <el-button type="text">{{dialogInsName}}</el-button>
                </el-col>
                <el-col :span="14">
                    <el-select style="width: 100%;" v-model="getMetrics.rom_model" filterable placeholder="固件类型">
                        <el-option value="" label="请选择"></el-option>
                        <el-option v-for="x in selectList" :key="x.id" :value="x.model" :label="x.model"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" icon="el-icon-search" @click="dialogSearch">查询</el-button>
                </el-col>
            </el-row>
            <el-table :data="switchData.metrics" border :show-header="false" stripe style="width: 100%">
                <el-table-column prop="name">
                </el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.display_switch"
                            active-color="#13ce66"
                            inactive-color="#eeeeee">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <div class="dialogBtn" v-if="switchData.metrics"><el-button type="primary" @click="save">保存</el-button></div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                data: [],
                name: '',
                dialogFormVisible: false,
                selectList: [],
                getMetrics: {
                    ins_id: 0,
                    page_name: '',
                    rom_model: '',
                    kind: 'car'
                },
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                editType: true,
                form: {
                    id: 0,
                    insId: 0,
                    stayTime: 0,
                    stayRadius: 0,
                },
                dialogTitle: '历史数据页面显示控制',
                switchData: [],
                dialogInsName:''
            }
        },
        mounted() {
            this.$http.get('/manage/rom-model/list').then(res => {
                this.selectList = res.data.data;
            })
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                    kind: 'car'
                }
                if (this.name.trim() != '') {
                    params.ins_name = this.name;
                }
                this.$http.get('/manage/page-display-control/list', { params: params }).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Edit(index) {
                this.$http.get('/manage/api-account-info/info/' + this.data[index].id).then(results => {
                    this.data[index].app_key = results['data']['data']['app_key']
                    this.data[index].app_secret = results['data']['data']['app_secret']
                });
            },
            openEdit(row, type) {
                this.dialogFormVisible = true;
                switch (type) {
                    case 'his':
                        this.dialogTitle = '历史数据页面显示控制';
                        break;
                    case 'edit':
                        this.dialogTitle = '参数编辑页面显示控制';
                        break;
                    case 'terminal':
                        this.dialogTitle = '终端管理页面显示控制';
                        break;
                    case 'onlineHis':
                        this.dialogTitle = '在线历史数据页面显示控制';
                        break;
                    case 'onlineLatest':
                        this.dialogTitle = '在线最新数据页面显示控制';
                        break;
                }
                this.dialogInsName = row.short_name;
                this.getMetrics.ins_id = row.ins_id;
                this.getMetrics.page_name = type;
            },
            dialogSearch() {
                this.$http.get('/manage/page-display-control/get-metrics', { params: this.getMetrics }).then(res => {
                    if(res.data.code == 0) {
                        this.switchData = res.data.data;
                    }else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                        this.switchData = [];
                    }
                })
            },
            save() {
                this.switchData.page = this.getMetrics.page_name;
                this.$http.post('/manage/page-display-control/update',this.switchData).then(rs=> {
                    if(rs.data.code == 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.switchData = [];
                        this.getMetrics.rom_model = '';
                        this.dialogFormVisible = false;
                    }else {
                        this.$message({
                            message: rs.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            dialogClose() {
                this.dialogFormVisible = false;
                this.switchData = []
                this.getMetrics.rom_model = '';
            }
        },
        components: { Pagination }
    }
</script>

<style scoped>
    .dialogBtn{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        margin-top: 15px;
    }
</style>